import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import Visibility from 'material-ui-icons/Visibility';
import VisibilityOff from 'material-ui-icons/VisibilityOff';
import IconButton from 'material-ui/IconButton';
import { FormControl } from 'material-ui/Form';
import StartBtn from './StartBtn';
// import axios from 'axios';
import REACT_LOGO_1 from './REACT_LOGO_1.svg';
// import ReactRedirect from 'react-redirect';
// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Redirect } from 'react-router';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  // withoutLabel: {
  //   marginTop: theme.spacing.unit * 3,
  // },
});

// function setCookie(key, value, seg) {
//   var now = new Date();
//   var time = now.getTime();
//   if (seg != null) {
//     var expireTime = time + (seg * 1000);
//     now.setTime(expireTime);
//     return document.cookie = key + '=' + value + ';expires=' + now.toGMTString() + ';path=/';
//   } else {
//     var date = new Date();
//     var midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
//     return document.cookie = key + '=' + value + ';expires' + midnight.toGMTString() + ';path=/';
//   }
// };

class SignInContainer extends Component {
  state = {
    email: '',
    password: '',
    login_admin: true,
    showPassword: false,
    redirectToVisualize: false,
  };

  handleLogin = event => {
    event.preventDefault();
    // const data = this.state;
    
    // axios.post('http://localhost:3000/users/login',  data)
    //   .then(response => {
    //     const { response: resp } = response.data;
    //     console.log(resp);
    //     if (resp) {
    //       window.location.href = `${ip}/urbo/design/design.html`;
    //       // window.location.href = "http://localhost:8080/urbo/design/design.html";
    //     } else {
    //       // window.location.href = "http://localhost/urbo/design/design.html";
    //       console.log('No coincidio la combinacion de emial password');
    //     }
    //   })
    //   // .catch(alert('Hubo un error de conexión, por favor intente más tarde.'))
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    });
  };

  
  render() {
    const { classes } = this.props;
    const { redirectToVisualize } = this.state;

    return (
      <div className={classes.root} >
        <div className='logo-urbo-container'>
          <img alt="React Logo" src={REACT_LOGO_1} />
        </div>
        <p>Bienvenido a tu Ciudad</p>
        <FormControl 
          fullWidth 
          className={classes.formControl}
          required
        >
          <InputLabel htmlFor="email">Email</InputLabel>
          <Input
            id="email-signin-field"
            value={this.state.email}
            onChange={this.handleChange('email')}
            required
            autoFocus={true}
          />
        </FormControl>

        <FormControl 
          fullWidth
          className={classes.formControl}
          required
        >
          <InputLabel htmlFor="password">Contraseña</InputLabel>
          <Input 
            id="password-field"
            type={this.state.showPassword ? 'text' : 'password'}
            value={this.state.password}
            onChange={this.handleChange('password')}
            required
            endAdornment={
              <InputAdornment position="end">
                <IconButton 
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        {console.log(redirectToVisualize)}
        {/* { redirectToVisualize &&
            <Router>
              <Redirect to='../visualize' />
  
            </Router>
        } */}
        
        <StartBtn text="Iniciar" handleClick={this.handleLogin} />

        
      </div>
    );
  }
}

SignInContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignInContainer);


// WEBPACK FOOTER //
// ./src/components/SignInContainer.js